import React, { useState, useEffect, useRef } from "react";
import {
  IconButton,
  InputAdornment,
  TextField,
  Modal,
  Box,
  CircularProgress,
} from "@mui/material";
import axios from "axios";
import { Controller, useForm, useWatch } from "react-hook-form";
import Select from "react-select";
import MuiSelect from "../ogComponent/muiSelect";
import BasicTabs from "../ogComponent/muiTabs";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import Spinner from "../ogComponent/spinner";
import { Toast } from 'primereact/toast';
import "./addEmp.css";

function AddEmployee() {
  const {
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
      employee_code: "",
      profile_photo: "",
      nationality: "",
      blood_group: "",
      education_level: "",
      password: "",
      gender: "",
      shift: "",
      employee_type: "",
      marital_status: "",
      work_experience: "",
      status: "",
      phone_number: "",
      email: "",
      branch: "",
      job_type: "",
      type_of_salary: "",
      department: "",
      job_position: "",
      joined_date: "",
      end_of_probation: "",
      effective_date: "",
      basic_salary: "",
      currency: "",
      benifits: "",
      bonus: "",
      deduction: "",
      city: "",
      state: "",
      pincode: "",
      office_phone: "",
      relative_name: "",
      relation: "",
      rel_phone_number: "",
      address_1: "",
      address_2: "",
      accHolder: "",
      accNumber: "",
      ifsccode: "",
      bankName: "",
      branchName: "",
      passportPhoto: "",
      sslcfile: "",
      adharfile: "",
      pancard: "",
      hr_to: [],
      reporting_to: [],
      roles: [],
    },
  });

  const branchWatch = useWatch({ control, name: 'branch' });

  const [selectedImage, setSelectedImage] = useState(null);
  const [branches, setBranches] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [jobPositions, setJobPositions] = useState([]);
  const [shifts, setShifts] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [roles, setRoles] = useState([]);
  const [jobTypes, setJobTypes] = useState([]);
  const [salaryTypes, setSalaryTypes] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [reportingOptions, setReportingOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [hrPositions, setHrpositions] = useState([]);
  const [error, setError] = useState(null);
  const [employee_code, setEmployee_code] = useState();
  const [isDepartmentDisabled, setDepartmentDisabled] = useState(true);
  const [isJobPositionDisabled, setJobPositionDisabled] = useState(true);
  const Genoptions = [{ name: "Male" }, { name: "Female" }, { name: "Other" }];
  const employeeOptions = [{ name: "Employee" }, { name: "Intern" }, { name: "Student" }];
  const token = localStorage.getItem("accessToken");
  const toast = useRef(null);

  useEffect(() => {
    const fetchEmployeeCode = async () => {
      try {
        const config = { headers: { Authorization: `Bearer ${token}` } };
        const response = await axios.get(
          `${process.env.REACT_APP_API}/api/account/next-employee-code/`,
          config
        );
        setEmployee_code(response.data?.next_employee_code);
        setValue("employee_code", response.data?.next_employee_code);
      } catch (error) {
        console.error("Error fetching employee code!:", error);
        setError("Failed to fetch employee code!. Please try again later.");
      }
    };
  
    fetchEmployeeCode();
  }, [token, setValue]);

  useEffect(() => {
    const fetchReportingOptions = async () => {
      try {
        const config = { headers: { Authorization: `Bearer ${token}` } };
        const response = await axios.get(`${process.env.REACT_APP_API}/api/account/users-list/`, config);
        setReportingOptions(
          response.data.map(user => ({
            value: user.id,
            label: user.name,
          }))
        );
      } catch (error) {
        console.error("Error fetching reporting options:", error);
        setError("Failed to fetch reporting options. Please try again later.");
      }
    };

    fetchReportingOptions();
  }, [token]);

  useEffect(() => {
    if (error && toast.current) {
      toast.current.show({
        severity: 'error',
        summary: 'Error',
        detail: error,
        life: 3000
      });
      setError(null);
    }
  }, [error]);

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 300,
    bgcolor: "white",
    borderRadius: "10px",
    boxShadow: 24,
    p: 4,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const SelectStyle = {
    control: (base, state) => ({
      ...base,
      minHeight: '38px',
      maxHeight: '38px',
      overflow: 'hidden'
    }),
    valueContainer: (base) => ({
      ...base,
      maxHeight: '38px',
      overflow: 'auto',
      flexWrap: 'nowrap',
      '&::-webkit-scrollbar': {
        width: '4px',
        height: '4px'
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '4px'
      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1'
      },
      padding: '2px 8px'
    }),
    multiValue: (base) => ({
      ...base,
      flexShrink: 0
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0
    })
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const config = { headers: { Authorization: `Bearer ${token}` } };

        const [branchesResponse, rolesResponse, jobTypesResponse, salaryTypesResponse, shiftResponse] = await Promise.all([
          axios.get(`${process.env.REACT_APP_API}/api/employee/branches/`, config),
          axios.get(`${process.env.REACT_APP_API}/api/common/roles/`, config),
          axios.get(`${process.env.REACT_APP_API}/api/employee/jobtypes/`, config),
          axios.get(`${process.env.REACT_APP_API}/api/employee/salarytypes/`, config),
          axios.get(`${process.env.REACT_APP_API}/api/employee/shifts/`, config),
        ]);

        setBranches(branchesResponse.data.map(branch => ({ name: `${branch.branch_name} - ${branch.location}`, id: branch.id })));
        setRoles(rolesResponse.data.map(role => ({ value: role.id, label: role.role_name })));
        setJobTypes(jobTypesResponse.data.map(item => ({ value: item.id, name: item.job_type })));
        setSalaryTypes(salaryTypesResponse.data.map(item => ({ value: item.id, name: item.type_of_salary })));
        setShifts(shiftResponse.data.map(item => ({ value: item.id, name: item.shift_name })));

      } catch (error) {
        console.error("Error fetching data:", error);
        setError('Failed to fetch necessary data. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [token]);

  const handleBranchChange = async (branchObj) => {
    setValue("branch", branchObj);
    setDepartmentDisabled(true);
    setJobPositionDisabled(true);
    setDepartments([]);
    setJobPositions([]);
    setHrpositions([]); // Reset HR positions on branch change

    try {
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const branchId = branchObj.id;

      const [deptsResponse, hrResponse] = await Promise.all([
        axios.get(`${process.env.REACT_APP_API}/api/employee/departments/?branches=${branchId}`, config),
        axios.get(`${process.env.REACT_APP_API}/api/account/hr-employees?branch_id=${branchId}`, config),
      ]);

      setDepartments(deptsResponse.data.map(dept => ({ name: dept.dep_name, id: dept.id })));
      setDepartmentDisabled(false);

      // Map the flat array of HR users directly to options
      const hrPositionsFlattened = hrResponse.data.map(detail => ({
        value: detail.id,
        label: detail.name
      }));
      setHrpositions(hrPositionsFlattened);

    } catch (error) {
      console.error("Error fetching departments or HR positions:", error);
      setError("Failed to fetch departments or HR positions. Please try again later.");
    }
  };

  const handleDepartmentChange = async (departmentObj) => {
    setValue("department", departmentObj);
    setJobPositionDisabled(true);
    setJobPositions([]);

    if (!branchWatch || !departmentObj) return;

    try {
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const branchId = branchWatch.id;
      const deptId = departmentObj.id;

      const response = await axios.get(
        `${process.env.REACT_APP_API}/api/employee/jobpositions/?branch=${branchId}&department=${deptId}`, 
        config
      );
      setJobPositions(response.data.map(position => ({ name: position.job_title, id: position.id })));
      setJobPositionDisabled(false);
    } catch (error) {
      console.error("Error fetching job positions:", error);
      setError("Failed to fetch job positions. Please try again later.");
    }
  };

  const handleImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setSelectedImage(e.target.result);
        setValue("profile_photo", e.target.result);
      };
      reader.readAsDataURL(event.target.files[0]);
    } else {
      setSelectedImage(null);
      setValue("profile_photo", "");
    }
  };

  const handleSelectImage = () => {
    document.getElementById("employee-image-input").click();
  };

  const handleReset = () => {
    reset();
    setSelectedImage(null);
    setDepartments([]);
    setJobPositions([]);
    setHrpositions([]);
    setDepartmentDisabled(true);
    setJobPositionDisabled(true);
  };

  const onSubmit = async (data) => {
    setIsSubmitting(true);
    try {
      const formData = new FormData();

      const getIdOrName = (value) => {
        if (value && typeof value === "object") {
          return value.id || value.value || value.name || value;
        }
        return value;
      };

      const appendMultipleValues = (key, values) => {
        if (Array.isArray(values)) {
          values.forEach((value) => {
            formData.append(key, String(getIdOrName(value)));
          });
        } else if (values && typeof values === "object") {
          formData.append(key, String(getIdOrName(values)));
        }
      };

      // Define bank and document fields
      const bankFields = ["accHolder", "accNumber", "ifsccode", "bankName", "branchName"];
      const documentFields = [
        { key: "passportPhoto", type: "passportPhoto" },
        { key: "sslcfile", type: "sslc" },
        { key: "adharfile", type: "adhar" },
        { key: "pancard", type: "pancard" },
      ];

      // Structure bank details
      const bankDetails = {
        account_holder_name: data.accHolder || "",
        account_number: data.accNumber || "",
        ifsc_code: data.ifsccode || "",
        bank_name: data.bankName || "",
        branch_name: data.branchName || "",
      };

      // Append bank details as bank_details[0]
      Object.entries(bankDetails).forEach(([key, value]) => {
        formData.append(`bank_details[0]${key}`, value);
      });

      // Structure documents
      documentFields.forEach(({ key, type }, index) => {
        if (data[key] instanceof File) {
          formData.append(`documents[${index}][document_type]`, type);
          formData.append(`documents[${index}][description]`, null);
          formData.append(`documents[${index}][file]`, data[key], data[key].name);
        }
      });

      // Append other fields
      Object.keys(data).forEach((key) => {
        if (bankFields.includes(key) || documentFields.some(doc => doc.key === key) || key === "profile_photo") {
          return; // Skip bank and document fields, already handled
        }

        let value = data[key];

        if (
          [
            "blood_group",
            "gender",
            "employee_type",
            "marital_status",
            "work_experience",
            "currency",
            "job_type",
            "type_of_salary",
            "department",
            "job_position",
            "branch",
            "shift",
          ].includes(key)
        ) {
          value = getIdOrName(value);
        }

        if (key === "status") {
          value = value === "Active" ? true : false;
        }

        if (["roles", "hr_to", "reporting_to"].includes(key)) {
          appendMultipleValues(key, value);
        } else if (Array.isArray(value)) {
          appendMultipleValues(key, value);
        } else {
          formData.append(key, value || "");
        }
      });

      // Handle profile photo
      if (selectedImage && typeof selectedImage === "string" && selectedImage.startsWith("data:")) {
        const profilePhotoFile = await fetch(selectedImage).then((res) => res.blob());
        formData.append("profile_photo", profilePhotoFile, "profile_photo.jpg");
      }

      const response = await axios.post(
        `${process.env.REACT_APP_API}/api/account/users/`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("Employee added successfully:", response.data);
      handleReset();
      setOpenModal(true);
      setTimeout(() => {
        setOpenModal(false);
      }, 3000);
    } catch (error) {
      console.error("Error adding employee:", error);

      if (error.response && error.response.data && error.response.data.email) {
        const emailError = error.response.data.email[0];
        toast.current.show({
          severity: 'error',
          summary: 'Error',
          detail: "This email already exists",
          life: 3000,
        });
      } else {
        toast.current.show({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to add employee. Please try again later.',
          life: 3000
        });
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  if (loading) {
    return <Spinner />;
  }

  return (
    <div className="addEmpContainer w-100 h-100 px-lg-5 py-lg-4 p-sm-1">
      <Toast ref={toast} position="bottom-right" />
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="formContainer w-100 h-100 d-flex gap-4 flex-column"
        style={{ backgroundColor: "#5853b70d" }}
      >
        <div className="firstContainer w-100 d-flex justify-content-center align-items-center">
          <div className="imageUploaderside d-flex justify-content-center align-items-center">
            <div className="image-uploader">
              {selectedImage ? (
                <div className="selected-image-container">
                  <img
                    src={selectedImage}
                    alt="Selected Employee Img"
                    className="selected-image"
                  />
                </div>
              ) : (
                <div className="upload-image-container">
                  <img
                    // src="https://icons.veryicon.com/png/o/internet--web/prejudice/user(NULL)user-128.png"
                    src="https://icons.veryicon.com/png/o/internet--web/prejudice/user-128.png"
                    alt=""
                    className="w-100 h-100"
                  />
                </div>
              )}
              <button
                type="button"
                className="select-image-button"
                onClick={handleSelectImage}
              >
                <i className="pen-icon fas fa-pen"></i>
                Select Image
              </button>
              <input
                type="file"
                id="employee-image-input"
                accept="image/*"
                onChange={handleImageChange}
                style={{ display: "none" }}
              />
            </div>
          </div>
          <div className="dataSide d-grid w-100">
            <div className="SingleData">
              <Controller
                name="name"
                control={control}
                rules={{ required: true }}
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    {...field}
                    className="form-control"
                    label="Name"
                    variant="outlined"
                    size="small"
                    placeholder="Reni Thomas"
                    error={!!error}
                    helperText={error?.message}
                    InputProps={{ sx: { height: "35px" } }}
                  />
                )}
              />
            </div>
            <div className="SingleData">
              <Controller
                name="employee_code"
                control={control}
                rules={{ required: true }}
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    {...field}
                    className="form-control"
                    label="Emp Code"
                    variant="outlined"
                    size="small"
                    value={employee_code || ""}
                    disabled
                    error={!!error}
                    helperText={error?.message}
                    InputProps={{ sx: { height: "35px" } }}
                  />
                )}
              />
            </div>
            <div className="SingleData">
              <Controller
                name="phone_number"
                control={control}
                rules={{
                  required: true,
                  pattern: {
                    value: /^\+?[1-9]\d{1,14}$/,
                    message: "Invalid phone number",
                  },
                }}
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    {...field}
                    type="tel"
                    className="form-control"
                    label="Phone Number"
                    variant="outlined"
                    size="small"
                    placeholder="+91 1234567890"
                    error={!!error}
                    helperText={error?.message}
                    InputProps={{ sx: { height: "35px" } }}
                  />
                )}
              />
            </div>
            <div className="SingleData">
              <Controller
                name="email"
                control={control}
                rules={{
                  required: true,
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "Invalid email address",
                  },
                }}
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    {...field}
                    type="email"
                    className="form-control"
                    label="Email"
                    variant="outlined"
                    size="small"
                    placeholder="abcd@gmail.com"
                    error={!!error}
                    helperText={error?.message}
                    InputProps={{ sx: { height: "35px" } }}
                  />
                )}
              />
            </div>
            <div className="SingleData">
              <Controller
                name="password"
                control={control}
                rules={{
                  required: true,
                  minLength: {
                    value: 8,
                    message: "min 8 letter",
                  },
                  pattern: {
                    value: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,}$/,
                    message: "must contain 1 letter & 1 number",
                  },
                }}
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    {...field}
                    type={showPassword ? "text" : "password"}
                    className="form-control"
                    label="Password"
                    variant="outlined"
                    size="small"
                    placeholder="Enter your password"
                    error={!!error}
                    helperText={error?.message}
                    InputProps={{
                      sx: { height: "35px" },
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={togglePasswordVisibility}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              />
            </div>
            <div className="SingleData">
              <Controller
                name="gender"
                control={control}
                rules={{ required: true }}
                render={({ field, fieldState: { error } }) => (
                  <MuiSelect
                    {...field}
                    label="Gender"
                    options={Genoptions}
                    className={`bg-white z-index-10`}
                    error={!!error}
                    helperText={error?.message}
                  />
                )}
              />
            </div>
            <div className="SingleData">
              <Controller
                name="branch"
                control={control}
                rules={{ required: true }}
                render={({ field, fieldState: { error } }) => (
                  <MuiSelect
                    {...field}
                    label="Branch Name"
                    options={branches}
                    className="bg-white"
                    error={!!error}
                    helperText={error?.message}
                    onChange={(event) => handleBranchChange(event.target.value)}
                  />
                )}
              />
            </div>
            <div className="SingleData">
              <Controller
                name="department"
                control={control}
                rules={{ required: true }}
                render={({ field, fieldState: { error } }) => (
                  <MuiSelect
                    {...field}
                    label="Department"
                    options={departments}
                    className="bg-white"
                    error={!!error}
                    helperText={error?.message}
                    disabled={isDepartmentDisabled}
                    onChange={(event) => handleDepartmentChange(event.target.value)}
                  />
                )}
              />
            </div>
            <div className="SingleData">
              <Controller
                name="job_position"
                control={control}
                rules={{ required: true }}
                render={({ field, fieldState: { error } }) => (
                  <MuiSelect
                    {...field}
                    label="Job Position"
                    options={jobPositions}
                    className="bg-white"
                    error={!!error}
                    helperText={error?.message}
                    disabled={isJobPositionDisabled}
                  />
                )}
              />
            </div>
            <div className="SingleData">
              <Controller
                name="shift"
                control={control}
                rules={{ required: true }}
                render={({ field, fieldState: { error } }) => (
                  <MuiSelect
                    {...field}
                    label="Shift"
                    options={shifts}
                    className="bg-white"
                    error={!!error}
                    helperText={error?.message}
                  />
                )}
              />
            </div>
             <div className="SingleData">
              <Controller
                name="employee_type"
                control={control}
                rules={{ required: true }}
                render={({ field, fieldState: { error } }) => (
                  <MuiSelect
                    {...field}
                    label="Emp Type"
                    options={employeeOptions}
                    className={`bg-white z-index-10`}
                    error={!!error}
                    helperText={error?.message}
                  />
                )}
              />
            </div>
            <div className="SingleData">
              <Controller
                name="hr_to"
                control={control}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={hrPositions}
                    className={`bg-white z-index-10 ${errors.hr_to ? "error-border" : ""}`}
                    isMulti
                    placeholder="Hr to"
                    getOptionLabel={(option) => option.label}
                    getOptionValue={(option) => option.value}
                    styles={SelectStyle}
                  />
                )}
              />
            </div>
            <div className="SingleData">
              <Controller
                name="reporting_to"
                control={control}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={reportingOptions}
                    className={`bg-white z-index-10 ${errors.reporting_to ? "error-border" : ""}`}
                    isMulti
                    placeholder="Reporting To"
                    getOptionLabel={(option) => option.label}
                    getOptionValue={(option) => option.value}
                    styles={SelectStyle}
                  />
                )}
              />
            </div>
            <div className="SingleData rolesField">
              <Controller
                name="roles"
                control={control}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={roles}
                    className={`bg-white z-index-10 ${errors.roles ? "error-border" : ""}`}
                    isMulti
                    placeholder="Select Roles"
                    styles={SelectStyle}
                  />
                )}
              />
            </div>
          </div>
        </div>
        <div className="containerCollapse w-100 d-flex flex-column gap-md-4">
          <BasicTabs
            tabs={["Personal Details", "Job Details", "Contact Details", "Bank Details", "Documents"]}
            control={control}
            jobTypes={jobTypes}
            salaryTypes={salaryTypes}
            type={"add"}
          />
        </div>
        <div className="fifthContainer d-flex justify-content-end me-md-5 me-3 gap-md-4 gap-2 pe-md-5 pe-2">
          <button
            type="button"
            className="btn text-white btn-success"
            onClick={handleReset}
          >
            Reset
          </button>
          <button
            type="submit"
            className="btn text-white d-flex align-items-center justify-content-center"
            style={{ backgroundColor: "#120e4d", minWidth: "120px", height: "38px" }}
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <CircularProgress size={24} color="inherit" sx={{ mr: 1 }} />
              </>
            ) : (
              "Add Employee"
            )}
          </button>
        </div>
      </form>
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          <CheckCircleOutlineIcon
            sx={{ color: "#4CAF50", fontSize: 60, mb: 2 }}
          />
          <Box sx={{ fontWeight: "bold", fontSize: 24, mb: 1 }}>Success</Box>
          <Box sx={{ color: "#555", mb: 2 }}>
            New employee Added Successfully !
          </Box>
        </Box>
      </Modal>
    </div>
  );
}

export default AddEmployee;